// extracted by mini-css-extract-plugin
export default {"container":"j4sr7fu1evexd3mg9rJw"};